export const BotIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33"
        d="M8 5.333V2.666H5.335m-4 6.667h1.333m10.667 0h1.333m-4.666-.667v1.333M6 8.666v1.333M4 5.333h8c.736 0 1.333.597 1.333 1.333v5.333c0 .737-.597 1.334-1.333 1.334H4a1.333 1.333 0 0 1-1.334-1.334V6.666c0-.736.597-1.333 1.334-1.333"
      />
    </svg>
  );
};
